import CalendarSettingsTabBar from "../components/calendarSettings/CalendarSettingsTabBar";
import GeneralSettingsTab from "../components/calendarSettings/generalSettingsTab/GeneralSettingsTab";
import SkillProfilesTab from "../components/calendarSettings/skillProfilesTab/SkillProfilesTab";
import MainContentWrapper from "../components/UI/pageStructure/MainContentWrapper";
import { useAppSelector } from "../store/hooks";

export default function CalendarSettingsPage() {
  const { selectedCalendarSettingsTab } = useAppSelector((state) => state.calendarSettingsSlice)

  return (
    <section className="flex flex-col relative">
      <div className="flex justify-end min-h-[43px]">
        <CalendarSettingsTabBar />
      </div>

      {/* TODO: figure out how to take the first element in the array passed to the tabs bar */}
      <MainContentWrapper
        classes="flex flex-col"
        firstTab="General"
        selectedTab={selectedCalendarSettingsTab}
      >
        {selectedCalendarSettingsTab === "General"
          ? <GeneralSettingsTab />
          : <SkillProfilesTab />
        }
      </MainContentWrapper>
    </section>
  );
}
